<div class="sam-margin-right sam-form-flex-row border-box" [ngClass]="showWarning ? 'k-bg-warning' : ''">
   <fa-icon
      [ngClass]="[
         fadeIconOpacity ? 'sam-margin input-icon icon-fade-opacity' : 'sam-margin input-icon',
         swapIconOpacity ? 'sam-margin input-icon icon-swap-opacity' : 'sam-margin input-icon',
         highlightIcon ? 'sam-margin input-icon sam-accent-color' : 'sam-margin input-icon'
      ]"
      [icon]="icon"
   ></fa-icon>

   <div [ngClass]="disabled ? 'sam-pointer-disabled input-field' : 'input-field'">
      <div class="k-form-field k-form-field-with-icon">
         <ng-container *ngIf="isFocused; else no_auto_focus">
            <ng-container [ngTemplateOutlet]="auto_focus"></ng-container>
         </ng-container>
         <fa-icon
            *ngIf="value?.length > 0 && !disabled"
            class="clear-search-text-icon sam-margin-right sam-margin-left"
            [icon]="clearFilterIcon"
            (click)="clearText()"
         >
         </fa-icon>
      </div>
   </div>
</div>

<ng-template #auto_focus>
   <kendo-textarea
      samwebAutoFocus
      rows="3"
      [disabled]="disabled"
      class="text-box"
      fxFlex="1 1 auto"
      (input)="textChanged($event.target.value)"
      (debouncedInput)="textChangedDebounced($event.target.value)"
      [value]="value"
      [placeholder]="header | translate"
      kendoTextBox
   ></kendo-textarea>
</ng-template>

<ng-template #no_auto_focus>
   <kendo-textarea
      rows="3"
      [disabled]="disabled"
      class="text-box"
      fxFlex="1 1 auto"
      (input)="textChanged($event.target.value)"
      (debouncedInput)="textChangedDebounced($event.target.value)"
      [value]="value"
      [placeholder]="header | translate"
      kendoTextBox
   ></kendo-textarea>
</ng-template>
